import { FooterBase } from "@Base/Site/FooterBase";
import { Subscription } from "@Tenants/Hw/Engagement/Subscription";

import "./Footer.scss";

export class Footer extends FooterBase
{
	public Subscription: Subscription;

	constructor()
	{
		super();
		this.Initialize();
	}

	public Initialize(): void
	{
		super.Initialize();
	};

	public override ConfigureSubscription(): void
	{
		this.Subscription = new Subscription();
		this.Subscription.ConfigureForm(this.FooterForm);
	};
}